import type { ReactElement } from 'react';

import { Flex } from '@rango-dev/whale';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import { dispatchCancellableAction, fetchProfileLeaderboard } from '../../../state/ProfileSlice';
import { Campaigns } from '../../CampaignsSidebar/Campaigns';
import { Leaderboard } from '../Leaderboard';
import { ProfileCard } from '../ProfileCard';

export function LoggedInUserSidebar(): ReactElement {
  const {
    data: leaderboard,
    loading: leaderboardLoading,
    error: leaderboardError,
  } = useAppSelector((state) => state.profile.profileLeaderboard);
  const params = useParams<{ username: string }>();
  const dispatch = useAppDispatch();

  const refetchProfileLeaderboard = () => {
    if (params.username) {
      dispatchCancellableAction(dispatch, fetchProfileLeaderboard, { username: params.username });
    }
  };

  return (
    <Flex direction="column" gap="5" width="434px" flexShrink="0">
      <ProfileCard />
      <Leaderboard
        error={leaderboardError}
        loading={leaderboardLoading}
        list={leaderboard}
        onRetry={refetchProfileLeaderboard}
      />
      <Campaigns />
    </Flex>
  );
}
